import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Container, AppBar, Stack, Link } from '@mui/material';
// config
import { HEADER } from '../../../config';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
import RouterLink from 'src/hooks/RouterLink';
import { Archive, CreditCard, Home, Sliders, Zap } from 'react-feather';
//
import navConfig from './NavConfig';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar)(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { pathname } = useLocation();
  const auth = useSelector(state => state.auth);
  const isRestaurant = auth.user.role === 2;

  // For restaurant users, display the horizontal menu similar to the header
  if (isRestaurant) {
    return (
      <RootStyle>
        <Container maxWidth={false}>
          <Stack direction="row" spacing={4} justifyContent="center">
            <Stack
              sx={
                pathname === '/dashboard/home' && {
                  border: '2px solid black',
                  p: 1,
                  borderRadius: '5px',
                }
              }
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Home size={22} />
              <Link component={RouterLink} href="/dashboard/home" variant="subtitle2">
                Accueil
              </Link>
            </Stack>
            <Stack
              sx={
                pathname === '/dashboard/missions' && {
                  border: '2px solid black',
                  p: 1,
                  borderRadius: '5px',
                }
              }
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Zap size={22} />
              <Link
                component={RouterLink}
                href="/dashboard/missions"
                variant="subtitle2"
              >
                Missions
              </Link>
            </Stack>
            <Stack
              sx={
                pathname === '/dashboard/my_applications' && {
                  border: '2px solid black',
                  p: 1,
                  borderRadius: '5px',
                }
              }
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Archive size={22} />
              <Link
                component={RouterLink}
                href="/dashboard/my_applications"
                variant="subtitle2"
              >
                Candidatures
              </Link>
            </Stack>
            <Stack
              sx={
                pathname === '/dashboard/invoices' && {
                  border: '2px solid black',
                  p: 1,
                  borderRadius: '5px',
                }
              }
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <CreditCard size={22} />
              <Link
                component={RouterLink}
                href="/dashboard/invoices"
                variant="subtitle2"
              >
                Factures
              </Link>
            </Stack>
            <Stack
              sx={
                pathname === '/dashboard/profile' && {
                  border: '2px solid black',
                  p: 1,
                  borderRadius: '5px',
                }
              }
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Sliders size={22} />
              <Link
                component={RouterLink}
                href="/dashboard/profile"
                variant="subtitle2"
              >
                Profil
              </Link>
            </Stack>
          </Stack>
        </Container>
      </RootStyle>
    );
  }
  
  // For admin/pro users, use the standard NavSectionHorizontal
  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={navConfig} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);